<button class="icon-button" type="button" [ngClass]="{'icon-button-active': active}">
  <ng-content></ng-content>
</button> 
